import { useCMSPage } from '@web-app/hooks/use-cms-page';
import type { InferGetServerSidePropsType } from 'next/types';

import { ARTICLES_TO_SHOW } from '@core/constant';
import { getSanityQuery } from '@core/sanity/utils';
import { ERouting } from '@core/type';
import { SanityBlogSearch } from '@core/type/sanity';
import { getLanguageFromTags } from '@core/util';

import { fetchSanityData } from '../../helpers/make-server-props/helpers/sanity';
import { isRedirect, makeServerSideProps } from '../../helpers/make-server-props/make-server-props';
import { ViewBlogSearchList } from '../../view';

export type BlogSearchQuery = {
  page?: string;
  q?: string;
};

export type PageBlogSearchProps = InferGetServerSidePropsType<typeof getServerSideProps>;

const PageBlogSearch = (props: PageBlogSearchProps) =>
  useCMSPage({
    ...props,
    ViewPage: ViewBlogSearchList,
  });

const getServerSideProps = makeServerSideProps<
  {
    cmsResult: SanityBlogSearch;
  },
  Record<string, string>,
  BlogSearchQuery,
  ERouting.BLOG_SEARCH
>(ERouting.BLOG_SEARCH, async (ctx) => {
  const res = await fetchSanityData<SanityBlogSearch>(ctx);
  if (isRedirect(res)) {
    return res;
  }

  ctx.prefetches.push(
    getSanityQuery('blogSearchArticlesQuery', {
      language: getLanguageFromTags(ctx.language),
      page: ctx.props.query.page,
      perPage: ARTICLES_TO_SHOW,
      q: ctx.props.query.q,
    }),
  );

  const cmsResult = res.props;

  return {
    props: {
      cmsResult: cmsResult,
      blogCategories: cmsResult.blogCategories,
    },
  };
});

export { getServerSideProps };

export default PageBlogSearch;
